import { METRO_ICON_BY_LOCATION_ID, type TMetroIcon } from 'shared/constants/buildingLabels';
import type { IBuildingCard } from 'shared/types/buildingCard';

export function getMetroIcon(card: IBuildingCard): TMetroIcon {
  return (card.locationId !== null && METRO_ICON_BY_LOCATION_ID[card.locationId]) || 'base';
}
